import { render } from "./ChangePasswordView.vue?vue&type=template&id=3f84bf1c&scoped=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js"

import "@/assets/css/login.css?vue&type=style&index=0&id=3f84bf1c&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f84bf1c"]])

export default __exports__